import { SITE_CONFIG } from "../siteConfig.js";
import { LegalDocument } from "./LegalDocument.js";

/** Plain-English service terms for a 3D render service. Draft: lawyer review required. */
export function termsDocument(cfg = SITE_CONFIG): LegalDocument {
  return new LegalDocument("Terms of service", cfg.legalUpdated, [
    {
      heading: "1. Who we are and what these terms cover",
      paragraphs: [
        `These terms apply to every project you order from ${cfg.name} (${cfg.legalEntity}). By accepting a written quote or paying a deposit you agree to them.`,
      ],
    },
    {
      heading: "2. Scope",
      paragraphs: [
        "We only do the work listed in your accepted quote: the package, the number of products and the deliverables named there. Anything else, such as extra products, extra angles or new scenes, is quoted separately before we start it.",
      ],
    },
    {
      heading: "3. Your materials",
      paragraphs: [
        "You promise that you own, or have the right to use, every photo, logo, drawing, link and other file you send us, and that using them will not infringe anyone else's rights. If someone makes a claim because of material you supplied, you are responsible for it.",
        "We build the model from your references. You approve a preview before final rendering. You are responsible for checking that the final images follow the rules of the marketplace or platform where you use them. We do not promise listing approval, ranking or sales.",
      ],
    },
    {
      heading: "4. Revisions",
      paragraphs: [
        "The number of revision rounds is stated in your quote. A round is one consolidated list of changes sent together. Changes after final approval, or beyond the included rounds, are charged at the rate in the quote or price sheet.",
      ],
    },
    {
      heading: "5. Turnaround",
      paragraphs: [
        "Turnaround times are estimates and start when we have the deposit and everything we need from you. Late feedback or missing files move the schedule. Rush delivery, where offered, is an agreed surcharge.",
      ],
    },
    {
      heading: "6. Delivery formats",
      paragraphs: [
        "Stills are delivered as JPG or PNG at the resolution in the quote. Spins and short videos are delivered as MP4. Other formats may be possible on request. We deliver by download link. Source files and 3D models are not included unless you buy them as an add-on.",
      ],
    },
    {
      heading: "7. Payment",
      paragraphs: [
        "Unless the quote says otherwise, a deposit is due before work starts and the balance is due before final files are released. Watermarked previews and free samples are for review only and may not be published or used commercially.",
      ],
    },
    {
      heading: "8. Ownership and licence",
      paragraphs: [
        "When we have received full payment, you receive a worldwide, perpetual licence to use the final delivered images and videos to market the product they show. Until full payment, all rights stay with us. We keep ownership of the 3D models, scenes, source files and tools we use, unless you buy them as an add-on.",
        "We may show finished work in our portfolio unless you tell us in writing that you want it kept private.",
      ],
    },
    {
      heading: "9. Refunds and cancellation",
      paragraphs: [
        "If you cancel before we start work, we refund the deposit. After work has started, you pay for the work completed so far and the deposit is not refundable, except where the law says otherwise. If we cannot deliver what the quote describes, we will fix it or refund the part not delivered.",
      ],
    },
    {
      heading: "10. Limitation of liability",
      paragraphs: [
        "To the extent the law allows, our total liability for any claim connected to a project is limited to the amount you paid for that project, and we are not liable for lost sales, lost profit or indirect losses. Nothing here limits liability that cannot legally be limited.",
      ],
    },
    {
      heading: "11. Governing law",
      paragraphs: [
        `These terms are governed by the law of ${cfg.governingLaw}. Disputes go to the courts there, unless the law gives you a right to go elsewhere.`,
      ],
    },
    {
      heading: "12. Changes and contact",
      paragraphs: [
        `We may update these terms. A project is governed by the version in force when you accepted its quote. Questions: ${cfg.contactEmail}.`,
      ],
    },
  ]);
}
